import React, { useRef, useEffect } from 'react';
import { useCodeMirror } from '@uiw/react-codemirror';
import { StreamLanguage } from "@codemirror/language";
import { javascript } from "@codemirror/lang-javascript";

export default function Editor({ value, onChange }) {
    const editorContainer = useRef(null);
    const { view } = useCodeMirror({
        container: editorContainer.current,
        value: value,
        extensions: [javascript()],
        onChange: onChange,
        height: "210px",
    });

    useEffect(() => {
        return () => {
            if (view) {
                view.destroy();
            }
        };
    }, [view]);

    return <div ref={editorContainer} className="code-mirror-wrapper" />;
}